import { Link } from "react-router-dom";
import { Phone, Mail, MapPin } from "lucide-react";
import { COMPANY } from "@/data/site";

export const Footer = () => (
  <footer data-testid="site-footer" className="bg-[#121212] text-[#fbf9f5] relative grain overflow-hidden">
    <div className="max-w-7xl mx-auto px-5 sm:px-8 py-16 grid gap-12 md:grid-cols-3">
      <div>
        <div className="flex items-center gap-3">
          <img src="/assets/logo.png" alt="Eunice 25 logo" className="h-14 w-auto object-contain" />
          <span className="font-display font-black text-2xl">
            EUNICE <span className="text-[#c8102e]">25</span>
          </span>
        </div>
        <p className="mt-4 font-display italic text-lg text-[#fbf9f5]/70">
          “{COMPANY.tagline}.”
        </p>
        <p className="mt-2 font-mono2 text-xs tracking-[0.2em] uppercase text-[#fbf9f5]/40">
          {COMPANY.founders}
        </p>
      </div>

      <div>
        <h3 className="font-mono2 text-xs tracking-[0.25em] uppercase text-[#c8102e] mb-5">Contact</h3>
        <ul className="space-y-4 text-sm">
          <li>
            <a href={COMPANY.phone1Href} data-testid="footer-phone-1" className="flex items-center gap-3 hover:text-[#c8102e] transition-colors">
              <Phone className="w-4 h-4 text-[#c8102e]" /> {COMPANY.phone1}
            </a>
          </li>
          <li>
            <a href={COMPANY.phone2Href} data-testid="footer-phone-2" className="flex items-center gap-3 hover:text-[#c8102e] transition-colors">
              <Phone className="w-4 h-4 text-[#c8102e]" /> {COMPANY.phone2}
            </a>
          </li>
          <li>
            <a href={`mailto:${COMPANY.email}`} data-testid="footer-email" className="flex items-center gap-3 hover:text-[#c8102e] transition-colors">
              <Mail className="w-4 h-4 text-[#c8102e]" /> {COMPANY.email}
            </a>
          </li>
          <li className="flex items-start gap-3 text-[#fbf9f5]/70">
            <MapPin className="w-4 h-4 text-[#c8102e] mt-0.5" />
            <span data-testid="footer-address">{COMPANY.address}</span>
          </li>
        </ul>
      </div>

      <div>
        <h3 className="font-mono2 text-xs tracking-[0.25em] uppercase text-[#c8102e] mb-5">Explore</h3>
        <ul className="space-y-3 text-sm">
          <li><Link to="/" data-testid="footer-nav-home" className="hover:text-[#c8102e] transition-colors">Home</Link></li>
          <li><Link to="/services" data-testid="footer-nav-services" className="hover:text-[#c8102e] transition-colors">Services</Link></li>
          <li><Link to="/gallery" data-testid="footer-nav-gallery" className="hover:text-[#c8102e] transition-colors">Gallery</Link></li>
          <li><Link to="/contact" data-testid="footer-nav-contact" className="hover:text-[#c8102e] transition-colors">Contact Us</Link></li>
        </ul>
      </div>
    </div>

    <div className="border-t border-white/10">
      <div className="max-w-7xl mx-auto px-5 sm:px-8 py-6 flex flex-col sm:flex-row items-center justify-between gap-3">
        <p className="font-mono2 text-xs tracking-[0.15em] uppercase text-[#fbf9f5]/40">
          © {new Date().getFullYear()} Eunice 25 · Werneth, Oldham
        </p>
        <p className="font-mono2 text-xs tracking-[0.15em] uppercase text-[#fbf9f5]/40">
          Totally affordable · Always professional
        </p>
      </div>
    </div>
  </footer>
);
